import { useEffect } from 'react'
import { Capacitor } from '@capacitor/core'
import { useAppSelector } from '../redux/hooks'

// on the web build, warn the user before they close/reload the tab while
// device-to-cloud items are still unsynced, so captured data isn't silently
// stranded. native (iPad) app termination can't be intercepted; that case is
// handled by a best-effort push on backgrounding in appStateChange instead.
export const usePendingSyncLeaveGuard = () => {
	const pendingDeviceToCloudCount = useAppSelector(state => state.dashboardData.pendingDeviceToCloudCount)
	useEffect(() => {
		if(Capacitor.isNativePlatform()) {
			return
		}
		if(pendingDeviceToCloudCount <= 0) {
			return
		}
		const handleBeforeUnload = (e: BeforeUnloadEvent) => {
			// showing the browser's native "leave site?" confirmation requires
			// preventDefault and, for older browsers, setting returnValue
			e.preventDefault()
			e.returnValue = ''
		}
		window.addEventListener('beforeunload', handleBeforeUnload)
		return () => window.removeEventListener('beforeunload', handleBeforeUnload)
	}, [pendingDeviceToCloudCount])
}
